// This directive shows an area graph of network activity on a BoxCaster.
angular.module('app.directives').directive('appBoxcasterNetworkGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            boxcasterId: '@'
        },
        controller($scope) {
            $scope.options = {
                renderer: 'multi',
                height: 40
            };
            $scope.series = [{
                name: 'ethernet tx',
                renderer: 'area',
                data: [],
                color: 'rgba(255,0,0,0.5)'
            }, {
                name: 'ethernet rx',
                renderer: 'area',
                data: [],
                color: 'rgba(0,255,255,0.5)'
            }];
            if (_.include(['o', 'p'], $scope.boxcasterId[0])) {
                $scope.series = $scope.series.concat([{
                    name: 'wireless tx',
                    renderer: 'area',
                    data: [],
                    color: 'rgba(0,0,255,0.5)'
                }, {
                    name: 'wireless rx',
                    renderer: 'area',
                    data: [],
                    color: 'rgba(255,255,0,0.5)'
                }]);
            }
            return $scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    _.each($scope.series, s => s.data.length = 0);
                    const interfaces = ['ethernet'];
                    if (_.include(['o', 'p'], $scope.boxcasterId[0])) { interfaces.push('wireless'); }
                    return _.each(interfaces, (iface, idx1) =>
                        _.each(['tx', 'rx'], function(direction, idx2) {
                            const data = newval[`network.interface.${iface}.${direction}_bytes`];
                            if (data != null) {
                                return Array.prototype.push.apply($scope.series[(2 * idx1) + idx2].data, _.map(data, function(v, k) {
                                    if (v < 0) {
                                        v = null;
                                    }
                                    return { x: parseInt(k), y: v };
                                }).sort((a, b) => a.x - b.x));
                            }
                        })
                    );
                }
            });
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            _.each([

            ], k => appBoxcasterGraph.registerData(k));
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },

        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_network_graph.js